import { mapActions } from "vuex";
import TableService from "@/services/table.service";
import { Parser } from "json2csv";
import {
  getGraphicsAsJsonString,
  extractShapeFileFromGraphicJSON,
  createValidGeometry
} from "./extractLogic";

const extractMixin = {
  data: function() {
    return {};
  },
  methods: {
    ...mapActions(["setSnack"]),
    downloadGraphicsAsOtherFormat(graphics, format) {
      let objectIDsToBeExported = [];

      for (let i = 0; i < graphics.length; i++) {
        objectIDsToBeExported.push(graphics[i].attributes.OBJECTID);
      }

      TableService.queryArcGISServerLayer(
        this.layer.url +
          "/" +
          this.layer.id +
          "/query?where=OBJECTID IN (" +
          objectIDsToBeExported.join(",") +
          ")" +
          "&outFields=*&f=" +
          format,
        {
          method: "GET",
          responseType: "blob"
        }
      ).then(response => {
        this.exportFileViaFileReader(response.data, format);
      });
    },
    exportFileViaFileReader(data, format) {
      let fr = new FileReader();

      fr.onload = evt => {
        try {
          let escapedString = evt.target.result.replace(/"/g, '"');
          let json = JSON.parse(escapedString);
          if (json.hasOwnProperty("error")) {
            this.setSnack(
              "Det oppstod en feil under eksporten. Prøv et annet format eller kontakt oss på epost."
            );
            return;
          } else {
            throw "File ok";
          }
        } catch (error) {
          let fileURL = window.URL.createObjectURL(new Blob([data]));
          let fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", "file." + format);
          document.body.appendChild(fileLink);

          fileLink.click();
        }
      };
      fr.readAsText(new Blob([data]));
    },
    async downloadGraphicsAsShapeFile(graphics) {
      let graphicsAsJsonString = await getGraphicsAsJsonString(graphics);

      extractShapeFileFromGraphicJSON(graphicsAsJsonString)
        .then(urlToExtractedShapefile => {
          document.location.href = urlToExtractedShapefile;
        })
        .catch(error => {
          this.setSnack("Eksport til Shape feilet.");
          console.error(error);
        });
    },
    getValidGeometry(geometryJson) {
      return createValidGeometry(geometryJson);
    },
    downloadGraphicsAsCSVFile(headers, graphics) {
      let csvHeaders = {};
      let items = [];

      for (let headerIndex in this.headers) {
        let header = this.headers[headerIndex];

        csvHeaders[header.value] = header.text;
      }

      for (let itemIndex in graphics) {
        let attributes = {};
        let item = graphics[itemIndex];
        for (let headerIndex in headers) {
          let header = headers[headerIndex];
          if (header.domain) {
            let codedValue = this.getCodedValue(
              header.domain,
              item.attributes[header.value]
            );
            attributes[header.value] = codedValue;
          } else {
            attributes[header.value] = item.attributes[header.value];
          }
        }

        items.push(attributes);
      }

      this.saveCSVFile(csvHeaders, items, "export");
    },
    getCodedValue(domain, value) {
      let result = domain.codedValues.find(
        codedValue => codedValue.code === value
      );

      if (typeof result === "undefined") {
        return value;
      } else {
        return result.name;
      }
    },
    saveCSVFile(headers, items, fileTitle) {
      try {
        const parser = new Parser({
          fields: headers ? Object.keys(headers) : Object.keys(items[1]),
          delimiter: ";"
        });
        const csvtest = "\uFEFF" + parser.parse(items);

        const exportedFilenmae = fileTitle + ".csv" || "export.csv";

        const blob = new Blob([csvtest], { type: "text/csv;charset=utf-8;" });
        if (navigator.msSaveBlob) {
          // IE 10+
          navigator.msSaveBlob(blob, exportedFilenmae);
        } else {
          const link = document.createElement("a");
          if (link.download !== undefined) {
            // feature detection
            // Browsers that support HTML5 download attribute
            const url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", exportedFilenmae);
            link.style.visibility = "hidden";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        }
      } catch (err) {
        console.error(err);
      }
    },
    convertToCSV(objArray) {
      const array =
        typeof objArray != "object" ? JSON.parse(objArray) : objArray;
      let str = "";

      for (let i = 0; i < array.length; i++) {
        let line = "";
        for (let index in array[i]) {
          if (line != "") line += ";";

          line += array[i][index];
        }

        str += line + "\r\n";
      }

      return str;
    }
  }
};

export default extractMixin;
